import {
    ChangeDetectionStrategy,
    Component,
    forwardRef,
    Input,
    OnInit,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { TimeService, utils } from '@bayclubs/utils';
import moment from 'moment-timezone';

const noop = () => {};
export const CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => DatesSelectorComponent),
    multi: true,
};

@Component({
    selector: 'app-dates-selector',
    templateUrl: './dates-selector.component.html',
    styleUrls: ['./dates-selector.component.scss'],
    providers: [CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class DatesSelectorComponent implements OnInit, ControlValueAccessor {
    private momentsInner: moment.Moment[] = [];

    @Input() public allowedDates: utils.BcDate[];
    @Input() public readonly: boolean = false;
    @Input() public isRequired: boolean = false;

    onChange = (dates: utils.BcDate[]) => {};
    onTouched = () => {};

    registerOnChange(fn: (dates: utils.BcDate[]) => void): void {
        this.onChange = fn;
    }

    registerOnTouched(fn: () => void): void {
        this.onTouched = fn;
    }

    writeValue(dates: utils.BcDate[]): void {
        this.momentsInner = dates.map((x) => this.time.toMoment(x));
        this.onChange(this.value);
    }
    get value(): utils.BcDate[] {
        const v = this.momentsInner.map((x) => this.time.toBcDate(x));
        console.log(v);

        return v;
    }

    constructor(private time: TimeService) {}

    ngOnInit() {}

    public onSelectClicked(day: utils.BcDate) {
        if (this.readonly) {
            return;
        }

        var existing = this.indexOfDate(day);
        if (existing >= 0) {
            this.momentsInner.splice(existing, 1);
        } else {
            this.momentsInner.push(this.time.toMoment(day));
        }
        this.onChange(this.value);
    }

    public isSelected(day: utils.BcDate): boolean {
        if (!this.momentsInner) {
            return false;
        }

        const thesame = this.indexOfDate(day);
        return thesame >= 0;
    }

    public indexOfDate(date: utils.BcDate) {
        const momentDate = this.time.toMoment(date);
        return this.momentsInner.findIndex((x) => x.isSame(momentDate, 'day'));
    }

    public get isNotValid() {
        const valid =
            this.isRequired &&
            (!this.momentsInner || this.momentsInner.length === 0);

        return valid;
    }
}
